import { gql } from '@apollo/client';

export default gql`
  mutation deleteRequest($_id: String) {
    deleteRequest(_id: $_id) {
      ok
      message
      error
    }
  }
`;
